import { ControlList, Dialog, useUrlParamsValueToString } from "@bsm/component";
import { useCallback, useEffect } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { useEmailListQuery } from "../../../hooks/useEmailListQuery";
import { useEmailConfigureForm } from "../../../hooks/useEmailConfigureForm";

export default function EmailConfigureContainer() {
    const { id } = useParams();
    const navigate = useNavigate();
    const urlParams = useUrlParamsValueToString();
    const { data, invalidateQuery } = useEmailListQuery(true);
    const control = useEmailConfigureForm(id ? parseInt(id) : undefined);

    useEffect(() => {
        if(data?.data?.length > 0 && !id) {
            navigate(`..?${urlParams}`);
        }
    }, [])
    
    const handleSubmited = useCallback(() => {
        invalidateQuery();
        navigate(`..?${urlParams}`);
    }, [invalidateQuery]);

    const handleClose = useCallback(() => {
        navigate(`..?${urlParams}`);
    }, []);

    return (
        <Dialog
            open
            title={id ? "Edit SMTP mail" : "Configure SMTP mail"}
            onClose={handleClose}
        >
            <ControlList
                {...control}
                defaultValue={{
                    id: id ? parseInt(id) : undefined,
                }}
                onCancel={handleClose}
                onSubmited={handleSubmited}
            />
        </Dialog>
    );
}
